import { Paper, Typography, Box, SxProps, Theme } from "@mui/material";
import { ReactNode } from "react";

interface AnalystResponseCardProps {
  title: string;
  content: ReactNode;
  color?: string;
  backgroundColor?: string;
  borderColor?: string;
  icon?: ReactNode;
  elevation?: number;
}

function AnalystResponseCard({
  title,
  content,
  color,
  backgroundColor,
  borderColor,
  icon,
  elevation = 1,
}: AnalystResponseCardProps) {
  const paperSx: SxProps<Theme> = {
    p: 2,
    ...(backgroundColor && { backgroundColor }),
    ...(color && { color }),
    ...(borderColor && {
      borderLeft: `3px solid`,
      borderLeftColor: borderColor,
    }),
  };

  return (
    <Paper elevation={elevation} sx={paperSx}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
        {icon && (
          <Box sx={{ display: "flex", alignItems: "center", ...(borderColor && { color: borderColor }) }}>
            {icon}
          </Box>
        )}
        <Typography variant="subtitle1" gutterBottom sx={{ mb: 0 }}>
          {title}
        </Typography>
      </Box>
      <Box>{content}</Box>
    </Paper>
  );
}

export default AnalystResponseCard;
